import React from "react";
import { upscaleCreditCost } from "../../../../data/aiOperationCredits";
import "./AiUpscaleControlMenu.css";

const PRESETS = [
  { id: "fast", label: "Fast" },
  { id: "balanced", label: "Balanced" },
  { id: "best", label: "Best" },
];

const SCALES = [
  { id: "2x", label: "2x" },
  { id: "4x", label: "4x" },
];

const OUTPUT_FORMATS = ["png", "webp", "jpg"];

const AiUpscaleControlMenu = ({
  onApply,
  busy = false,
}) => {
  const [preset, setPreset] = React.useState("balanced");
  const [scale, setScale] = React.useState("2x");
  const [outputFormat, setOutputFormat] = React.useState("png");

  const handleApply = () => {
    if (typeof onApply !== "function") return;
    onApply({
      quality: preset,
      scale,
      output_format: outputFormat,
      ...(preset === "best" ? { polish: true } : {}),
    });
  };

  return (
    <div className="ai-upscale-control-menu-container">
      <div className="ai-upscale-field">
        <p className="ai-upscale-field-label">Preset</p>
        <div className="ai-upscale-chip-row">
          {PRESETS.map((p) => (
            <button
              type="button"
              key={p.id}
              className={`ai-upscale-chip ${preset === p.id ? "selected" : ""}`}
              onClick={() => setPreset(p.id)}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>

      <div className="ai-upscale-field">
        <p className="ai-upscale-field-label">Scale</p>
        <div className="ai-upscale-chip-row">
          {SCALES.map((s) => (
            <button
              type="button"
              key={s.id}
              className={`ai-upscale-chip ${scale === s.id ? "selected" : ""}`}
              onClick={() => setScale(s.id)}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      <div className="ai-upscale-field">
        <p className="ai-upscale-field-label">Output format</p>
        <select
          className="ai-upscale-select"
          value={outputFormat}
          onChange={(e) => setOutputFormat(e.target.value)}
        >
          {OUTPUT_FORMATS.map((fmt) => (
            <option key={fmt} value={fmt}>
              {fmt.toUpperCase()}
            </option>
          ))}
        </select>
      </div>

      <button
        type="button"
        className="ai-upscale-apply-btn"
        onClick={handleApply}
        disabled={busy}
      >
        {busy
          ? "Upscaling…"
          : `Upscale · ${upscaleCreditCost(scale, preset)}`}
      </button>
    </div>
  );
};

export default AiUpscaleControlMenu;
